



'use strict';

export const sizes = {
    xs: 575,
    sm: 767,
    md: 991,
    lg: 1200,
};


export function hasSize (size) {
    if ( !sizes[size] ) {
        throw `Size "${size}" not found.`;
    }

    return sizes[size] >= window.innerWidth;
}
